import React from 'react'
import structuredClone from '@ungap/structured-clone';
import Base, {clearLeg} from "./base";
import {mergeDeep, shuffle} from "../utils";

class Game extends Base {

  FINAL_SCORE = 501
  EXTREME_SERIES = 15

  constructor(ctx, data, urls = window.URLS, type_game = '501') {
    super(ctx, data, urls)
    if (type_game === this.get('game').type_game) {
      this.set('game', mergeDeep({}, {
        data: [[]],
      }, this.get('game')))
      this.restoreSelected()
    }
  }

  get maxSeries() {
    const leg = this.data
    let diff = 1
    if (!!this.getWinnerNumberByLeg(leg)) diff = 0
    return leg.length >= this.EXTREME_SERIES ? leg.length + diff : this.EXTREME_SERIES
  }

  validateScore(score, i, p) {
    if (score > 180) return false
    const leg = structuredClone(this.data)
    const series = leg.at(i) || [{}, {}]
    series[p] = {score: score}
    leg[i] = series
    const remainder_score = this.calculateRemainder(leg, p)
    if (leg.length === i + 1) {
      return remainder_score >= 0 && remainder_score !== 1
    } else {
      return remainder_score >= 0
    }
  }

  getDataAndScore(ss) {
    const legs = this.get('game').data
    const [i, p] = this.get('selected');
    const leg = legs.at(-1)
    const series = leg.at(i) || [{}, {}]
    series[p] = ss
    leg[i] = series
    const remainder_score = this.calculateRemainder(leg, p)
    if (leg.length === i + 1 && remainder_score === 0 && !ss.sectors && !leg[i][p].darts) {
      leg[i][p].darts = null
    }
    legs[legs.length - 1] = clearLeg(leg)
    return [legs, this.calculateTotalScore(legs)]
  }

  getLastPosition() {
    const leg = this.data
    const winner_number_leg = this.getWinnerNumberByLeg(leg)
    const winner_number_player = {1: 0, 2: 1}
    const participantNumber = this.getParticipantNumber()
    return [leg.length - 1, winner_number_leg ? winner_number_player[winner_number_leg] : participantNumber]
  }

  checkBotShot(input) {
    const [, p] = this.get('selected')
    const remainderScore = this.calculateRemainder(this.data, p)

    const nextRemainderScore = remainderScore - input
    return nextRemainderScore === 0 || nextRemainderScore > 1
  }

  getHitsForClose(score) {
    const hists = []
    const doubles = {};
    for (let i = 1; i <= 20; i++) {
      doubles[2 * i] = [i, 2];
    }
    doubles[50] = [25, 2];

    if (score in doubles) hists.push(doubles[score])

    for (const doubleScore of Object.keys(doubles).sort((a, b) => b - a)) {
      const doubleValue = parseInt(doubleScore);
      if (doubleValue < score && (score - doubleValue) <= 40) {
        if ((score - doubleValue) % 2 === 0 && (score - doubleValue) / 2 <= 20) {
          const intermediateThrow = [Math.floor((score - doubleValue) / 2), 2];
          hists.push(intermediateThrow);
          // bestThrows.push([intermediateThrow, doubles[doubleValue]]);
        } else if ((score - doubleValue) <= 20 && score - doubleValue !== 1) {
          const intermediateThrow = [score - doubleValue, 1];
          hists.push(intermediateThrow);
          // bestThrows.push([intermediateThrow, doubles[doubleValue]]);
        }
      }
    }

    return hists;
  }


  getPriorityHits() {
    const [, p] = this.get('selected')
    const hits = this.getPriorityBaseHits()

    const remainderScore = this.calculateRemainder(this.data, p)

    if (remainderScore >= 80) return hits

    const hitsForClose = this.getHitsForClose(remainderScore)
    const hitsFilter = hits.filter(hit =>
      !hitsForClose.some(hitClose => hit[0] === hitClose[0] && hit[1] === hitClose[1])
    );
    return hitsForClose.concat(shuffle(hitsFilter))
  }

  getWinnerNumberByLeg(leg) {
    const [score_1, score_2] = this.calculateScore(leg)
    if (score_1 >= this.FINAL_SCORE) {
      return 1
    }
    if (score_2 >= this.FINAL_SCORE) {
      return 2
    }
  }
  /* 501 */

  calculateRemainder(leg, p) {
    return leg.reduce((remainder, series) => {
      return remainder - (series[p].score || 0);
    }, this.FINAL_SCORE)
  }
}

export default Game